import {Pipe, PipeTransform} from '@angular/core';
import {TaskStatuses} from 'src/app/current-sked/shared/task-statuses';
import {getTaskStatusInfo, TaskStatusInfo} from '../task-status.utils';

@Pipe({
  name: 'taskStatusInfo',
  standalone: true,
  pure: true,
})
export class TaskStatusInfoPipe implements PipeTransform {
  transform(status: TaskStatuses): TaskStatusInfo {
    if (!status) {
      return {text: '', color: ''};
    }
    return getTaskStatusInfo(status);
  }
}
